// ==========================================
// SelectedStockContext.jsx
// ==========================================

import { createContext, useContext, useState } from "react";

import axios from "axios";

const FavStockContext = createContext();
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FavStockProvider = ({ children }) => {
  // ==========================================
  // STATES
  // ==========================================

  const [selectedStock, setSelectedStock] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState([]);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  // ==========================================
  // ADD SELECTED STOCK
  // ==========================================
  const getSetterByType = (type) => {
    return type?.toUpperCase() === "INDEX"
      ? setSelectedIndex
      : setSelectedStock;
  };

  const getSelectedByType = (type) => {
    return type?.toUpperCase() === "INDEX" ? selectedIndex : selectedStock;
  };

  const addSelectedStock = async ({
    userID,
    symbol,
    securityId,
    type = "STOCK",
  }) => {
    try {
      console.log("\n==============================");

      console.log("📥 ADD SELECTED STOCK CONTEXT");

      console.log("==============================");

      console.log("➡️ User ID:", userID);

      console.log("➡️ Symbol:", symbol);

      console.log("➡️ Security ID:", securityId);
      const formattedType = type.toUpperCase();

      setLoading(true);

      setError(null);

      const response = await axios.post(`${BASE_URL}/api/add-selected-stock`, {
        userID,
        symbol,
        securityId,
        type: formattedType,
      });

      console.log("✅ Backend Response:", response.data);

      const stockData = response.data?.data;

      if (formattedType === "INDEX") {
        setSelectedIndex(stockData);
      } else {
        setSelectedStock(stockData);
      }

      console.log("📦 Selected Stock Data:", stockData);

      return stockData;
    } catch (err) {
      console.error("❌ Add Selected Stock Error:", err);

      setError(err?.response?.data?.message || "Failed to add stock");

      return null;
    } finally {
      setLoading(false);
    }
  };
  const removeSelectedStock = async ({ userID, symbol, type }) => {
    try {
      console.log("\n==============================");

      console.log("🗑️ REMOVE FAV STOCK CONTEXT");

      console.log("==============================");

      console.log("➡️ User ID:", userID);

      console.log("➡️ Symbol:", symbol);
      console.log("Type is ", type);
      const formattedType = type.toUpperCase();

      setLoading(true);

      setError(null);

      // ==========================================
      // CALL BACKEND
      // ==========================================

      const response = await axios.delete(
        `${BASE_URL}/api/remove-selected-stock`,
        {
          data: {
            userID,

            symbol,
            type: formattedType,
          },
        },
      );

      console.log("✅ Backend Remove Response:", response.data);

      // ==========================================
      // CLEAR LOCAL STATE
      // ==========================================

      if (formattedType === "INDEX") {
        setSelectedIndex([]);
      } else {
        setSelectedStock([]);
      }

      console.log("🧹 Selected Stock Cleared");

      return response.data;
    } catch (err) {
      console.error("❌ Remove Fav Stock Error:", err);

      setError(err?.response?.data?.message || "Failed to remove stock");

      return null;
    } finally {
      setLoading(false);
    }
  };

  // ==========================================
  // GET FAV STOCK CONTEXT FUNCTION
  // ==========================================

  const getSelectedStock = async (userID, type = "STOCK") => {
    try {
      console.log("\n==============================");

      console.log("📥 GET FAV STOCK CONTEXT");

      console.log("==============================");

      console.log("➡️ User ID:", userID);
      const formattedType = type.toUpperCase();

      setLoading(true);

      setError(null);

      // ==========================================
      // CALL BACKEND
      // ==========================================

      const response = await axios.post(`${BASE_URL}/api/get-selected-stock`, {
        userID,
        type: formattedType,
      });

      console.log("✅ Backend Response:", response.data);

      const stockData = response.data?.data || [];

      if (formattedType === "INDEX") {
        setSelectedIndex(stockData);
      } else {
        setSelectedStock(stockData);
      }

      console.log("📦 Fav Stock Data:", stockData);

      // ==========================================
      // UPDATE STATE
      // ==========================================

      // setSelectedStock(stockData);
      if (formattedType === "INDEX") {
        setSelectedIndex(stockData);
      } else {
        setSelectedStock(stockData);
      }

      return stockData;
    } catch (err) {
      console.error("❌ Get Fav Stock Error:", err);

      setError(err?.response?.data?.message || "Failed to fetch fav stock");

      return [];
    } finally {
      setLoading(false);
    }
  };
  // ==========================================
  // REMOVE SELECTED STOCK
  // ==========================================

  const clearSelectedStock = () => {
    console.log("🗑️ Clearing Selected Stock");

    setSelectedStock(null);
  };

  //   const clearSelectedStock = () => {
  //   setSelectedStock([]);
  // };

  const clearSelectedIndex = () => {
    setSelectedIndex([]);
  };

  const clearSelectedByType = (type = "STOCK") => {
    if (type.toUpperCase() === "INDEX") {
      setSelectedIndex([]);
    } else {
      setSelectedStock([]);
    }
  };

  // ==========================================
  // CONTEXT VALUE
  // ==========================================

  const value = {
    selectedStock,

    setSelectedStock,

    addSelectedStock,

    clearSelectedStock,
    removeSelectedStock,
    selectedIndex,
    getSelectedStock,
    clearSelectedIndex,

    loading,

    error,
  };

  return (
    <FavStockContext.Provider value={value}>
      {children}
    </FavStockContext.Provider>
  );
};

// ==========================================
// CUSTOM HOOK
// ==========================================

export const useSelectedStock = () => {
  return useContext(FavStockContext);
};
